import React, {useEffect, useState, useRef} from "react";
import useIsMobile from "../hooks/useIsMobile";
import { PageContainer } from "./Utilities";

import bgDesktop from '../img/intro-lungs.jpg';

// eslint-disable-next-line no-empty-pattern
const IntroBackground = React.forwardRef(({playVideo}, ref) => {

  const isMobile = useIsMobile();
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {

    let interval;
    // when playVideo is true, load (if not), play the video or hide the video
    if (isMobile === null) return;

    if (playVideo === true) {
      
      if (!videoLoaded) {
        videoRef.current.defaultMuted = true;
        videoRef.current.src = `./vids/endframe_${isMobile ? "mobile" : "desktop"}.mp4`
        videoRef.current.removeAttribute("autoplay");
          videoRef.current.currentTime = 0;
        setVideoLoaded(true);
        return;
      }
      
      clearInterval(interval);
      interval = setInterval(() => {
        
        videoRef.current.play();
        
        clearInterval(interval);
      }, 100);
      
    } else {
      clearInterval(interval);
      interval = setInterval(() => {
        if (!videoLoaded) return;
        videoRef.current.pause();
        clearInterval(interval);
      }, 100);
      
    }

  }, [playVideo, isMobile, videoLoaded]);

  return (
    <div ref={ref} id="IntroBackground" className={`fixed w-full h-full min-h-screen block z-[-1]`}>
      
      <PageContainer className="fixed items-center scale-[85%] origin-bottom-left md:left-[-15%] md:bottom-[-20%] lg:scale-100 lg:bottom-[-120px] lg:left-[-19%] lg:top-[-5%]">
      
        <video 
          ref={videoRef} 
          id="introVideo"
          src=""
          className={`video-background z-[0] !absolute intro-video-background`}
          playsInline={true}
          webkit-playsinline="true"
          preload="auto"
          muted="muted"
          // autoplay={true}
          autoPlay
          loop
          type="video/mp4"/>

      </PageContainer>

      <img src={bgDesktop} alt="" className="fixed w-screen h-screen z-[1] hidden lg:block object-cover mix-blend-exclusion opacity-50"/>

    </div>
  );
});

export default IntroBackground;